var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippingMarine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340.345,
    height: 194.635,
    viewBox: "0 0 340.345 194.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shipping_Marine",
    "data-name": "Shipping & Marine",
    transform: "translate(0.132 613.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3497",
    transform: "translate(4.712 -609.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3505",
    transform: "translate(0 85.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3507",
    d: "M-284.952-68.534a58.628,58.628,0,0,0,25.784-26.006l21.114-42.23H-339.369l-7.717,15.434a10.665,10.665,0,0,1-9.539,5.9H-499.341A10.665,10.665,0,0,1-510.006-126.1v-10.665h-58.657l31.3,73.039",
    transform: "translate(568.663 136.769)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3509",
    transform: "translate(0.048 149.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3511",
    d: "M-332.008-.961c-9.875,2.618-12.485,9.708-26.614,9.708h-.047C-376,8.747-376-1.917-393.331-1.917s-17.33,10.665-34.66,10.665S-445.322-1.917-462.652-1.917s-17.33,10.665-34.661,10.665h.048c-17.331,0-17.331-10.665-34.661-10.665s-17.33,10.665-34.661,10.665-17.33-10.665-34.661-10.665-17.33,10.665-34.661,10.665h-.047c-14.13,0-16.739-7.09-26.614-9.708",
    transform: "translate(662.569 1.917)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3513",
    transform: "translate(0.048 175.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3515",
    d: "M-332.008-.961c-9.875,2.619-12.485,9.708-26.614,9.708h-.047C-376,8.747-376-1.917-393.331-1.917s-17.33,10.665-34.66,10.665S-445.322-1.917-462.652-1.917s-17.33,10.665-34.661,10.665h.048c-17.331,0-17.331-10.665-34.661-10.665s-17.33,10.665-34.661,10.665-17.33-10.665-34.661-10.665-17.33,10.665-34.661,10.665h-.047c-14.13,0-16.739-7.089-26.614-9.708",
    transform: "translate(662.569 1.917)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3517",
    transform: "translate(31.995 42.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3519",
    d: "M0-21.423V-42.752H95.984V21.237",
    transform: "translate(0 42.752)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3521",
    transform: "translate(31.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3523",
    d: "M0-42.846V-85.505H63.989v42.659",
    transform: "translate(0 85.505)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3525",
    transform: "translate(85.319 21.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3527",
    d: "M0,0H10.665",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3529",
    transform: "translate(53.324 21.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3531",
    d: "M-10.711,0H-21.376",
    transform: "translate(21.376)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3533",
    transform: "translate(53.324 63.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3535",
    d: "M-10.711,0H-21.376",
    transform: "translate(21.376)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3537",
    transform: "translate(85.319 63.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3539",
    d: "M-10.711,0H-21.376",
    transform: "translate(21.376)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3541",
    transform: "translate(117.313 63.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3543",
    d: "M-10.711,0H-21.376",
    transform: "translate(21.376)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3545",
    transform: "translate(127.978 42.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3547",
    d: "M-10.711,0H-21.376",
    transform: "translate(21.376)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3549",
    transform: "translate(95.984 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3551",
    d: "M-10.711,0H-21.376",
    transform: "translate(21.376)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3553",
    transform: "translate(186.635 85.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3555",
    d: "M0-21.423v-21.33H42.659",
    transform: "translate(0 42.753)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3557",
    d: "M426.744-378.787H384.084v-21.329h42.659Z",
    transform: "translate(-197.45 464.106)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3559",
    d: "M512.25-378.787H469.591v-21.329H512.25Z",
    transform: "translate(-240.297 464.106)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3561",
    d: "M597.755-378.787H555.1v-21.329h42.659Z",
    transform: "translate(-283.143 464.106)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3563",
    d: "M469.5-421.54H426.838v-21.329H469.5Z",
    transform: "translate(-218.873 485.529)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3565",
    d: "M555-421.54H512.343v-21.329H555Z",
    transform: "translate(-261.719 485.529)",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3567",
    transform: "translate(90.651 127.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3569",
    d: "M0,0H.053",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3571",
    transform: "translate(133.257 127.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3573",
    d: "M0,0H.053",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3575",
    transform: "translate(175.97 127.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3577",
    d: "M0,0H.053",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3579",
    transform: "translate(111.981 127.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3581",
    d: "M0,0H.053",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3583",
    transform: "translate(154.587 127.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3585",
    d: "M0,0H.053",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3587",
    transform: "translate(197.299 127.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3589",
    d: "M0,0H.053",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3591",
    transform: "translate(245.291 106.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3593",
    d: "M0,0H74.654",
    fill: "none",
    stroke: "#1c6bfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingMarine);
export default __webpack_public_path__ + "static/media/Shipping & Marine.9801b275ade5754502cffd2722076793.svg";
export { ForwardRef as ReactComponent };